
<script>
const baseToolBar = {
  label: '操作',
  hidden: false,
  width: '',
  minWidth: '',
  align: 'center',
  fixed: false
}
const defaultConfig = {
  showStatus: false,
  renderSize: 30,
  offsetSize: 10
}
export default {

  name: 'EditDataTable',

  inheritAttrs: false,

  props: {
    head: {
      type: Array,
      required: true
    },
    rowKeyField: {
      type: String,
      default: 'id'
    },
    showSelection: Boolean,
    rowSelection: {
      type: Boolean,
      default: true
    },
    // 勾选限制
    selectLimit: {
      type: Number,
      default: -1
    },
    showNumber: Boolean,
    toolBar: {
      type: Object,
      default: () => ({
        label: '操作',
        hidden: false,
        width: '',
        minWidth: '',
        align: 'center',
        fixed: false
      })
    },
    // 默认自适应当前屏高度
    height: {
      type: [String, Number],
      default: 'auto'
    },
    maxHeight: {
      type: [String, Number],
    },
    minHeight: {
      type: [String, Number],
    },
    // 距离底部距离
    bottomSpace: {
      type: Number,
      default: 0
    },
    // 多级嵌套数据 user:{name:'名称'} prop可以定义成user.name
    showOverflowTooltip: { // 内容超出隐藏
      type: Boolean,
      default: true
    },
    reserveSelection: { // 记忆勾选
      type: Boolean,
      default: false
    },
    // 没有分页
    noPagination: Boolean,
    // 是否可编辑
    editable: Boolean,
    // 显示新增行
    showAdd: Boolean,
    selectable: {
      // 编辑执行前操作
      type: Function
    },
    pagerCount: {
      type: Number,
      default: 7
    }
  },
  render(h) {
    const _this = this
    const columnRender = function(col, h) {
      if (col.hidden === true || (typeof col.hidden === 'function') && col.hidden()) return null
      if (!col.hasOwnProperty('children') || col.children.length === 0) {
        if (col.hidden === true || (typeof col.hidden === 'function') && col.hidden()) return null
        return h(_this.editable ? 'elx-editable-column' : 'elx-table-column', {
          props: {
            ...col,
            width: col.width ? col.width.toString() : null,
            minWidth: col.minWidth ? col.minWidth.toString() : null,
            showOverflowTooltip: _this.$scopedSlots[col.prop] ? false : col.showOverflowTooltip !== undefined ? col.showOverflowTooltip : _this.showOverflowTooltip,
            formatter: null,
            sortable: col.sortable === undefined ? !_this.editable : col.sortable
          },
          key: col.columnKey || col.prop,
          scopedSlots: {
            header: (props) => {
              if (_this.$scopedSlots[col.prop + 'Header']) {
                return h('div', [
                  _this.$scopedSlots[col.prop + 'Header']({
                    ...props
                  })
                ])
              }
            },
            edit: (props) => {
              if (_this.$scopedSlots[col.prop + 'Edit']) {
                return h('div', [
                  _this.$scopedSlots[col.prop + 'Edit']({
                    ...props
                  })
                ])
              }
            },
            default: (props) => {
              if (_this.$scopedSlots[col.prop]) {
                return h('div', [
                  _this.$scopedSlots[col.prop]({
                    ...props
                  })
                ])
              } else {
                return h('span', {
                  style: col.cellStyle && typeof col.cellStyle === 'function'
                    ? col.cellStyle(_this._renderCellValue(props.row, props.column.property), props.row, props.column, props.$index) : null,
                  domProps: {
                    innerHTML: (col.formatter && typeof col.formatter === 'function')
                      ? col.formatter(_this._renderCellValue(props.row, props.column.property), props.row, props.column, props.$index) : _this._renderCellValue(props.row, props.column.property)
                  }
                })
              }
            }
          }
        })
      } else {
        if (Array.isArray(col.children) && col.children.length) {
          return h(_this.editable ? 'elx-editable-column' : 'elx-table-column', {
              props: {
                ...col,
                width: col.width ? col.width.toString() : null,
                minWidth: col.minWidth ? col.minWidth.toString() : null,
                showOverflowTooltip: _this.$scopedSlots[col.prop] ? false : col.showOverflowTooltip !== undefined ? col.showOverflowTooltip : _this.showOverflowTooltip,
                formatter: null
              },
              attrs: {
                label: col.label || col.prop
              }
            }, [...col.children.map(column => columnRender(column, h))]
          )
        }
        console.error(`[ETable warn] children need Array and can't be empty`)
        return null
      }
    }
    return h('div', {
      class: {
        'data-table-container': true,
        'no-pagination': _this.noPagination
      }
    }, [
      h(_this.editable ? 'elx-editable' : 'elx-table', {
        ref: 'elTable',
        props: {
          ...this.$attrs,
          editConfig: this.tableConfig,
          rowKey: _this.rowKeyField,
          rowClassName: _this._tableRowClassName,
          height: _this.getTableHeight,
          maxHeight: _this.maxHeight,
          minHeight: _this.minHeight
        },
        on: {
          ...this.$listeners,
          'row-click': this._handleRowClick,
          'selection-change': this._handleSelection
        },
        directives: [{
          name: 'loading',
          value: _this.$attrs.loading
        }],
        scopedSlots: {
          empty: function() {
            return _this.$slots.empty
          },
          append: function() {
            return _this.$slots.append
          }
        }
      },
      [
        _this.showSelection ? h(_this.editable ? 'elx-editable-column' : 'elx-table-column', {
          props: {
            selectable: _this._cumSelectable,
            reserveSelection: _this.reserveSelection
          },
          attrs: {
            type: 'selection',
            align: 'center',
            width: '50'
          }
        }) : null,
        _this.showNumber ? h(_this.editable ? 'elx-editable-column' : 'elx-table-column', {
          attrs: {
            type: 'index',
            label: '序号',
            align: 'center',
            width: '60'
          },
          scopedSlots: {
            header: (props) => {
              if (_this.$scopedSlots['indexHeader']) {
                return h('div', [
                  _this.$scopedSlots['indexHeader']({
                    ...props
                  })
                ])
              }
            },
          }
        }) : null,
        _this.head.map(col => columnRender(col, h)),
        !_this.getToolBar.hidden ? h(_this.editable ? 'elx-editable-column' : 'elx-table-column', {
          props: {
            ..._this.getToolBar,
            width: _this.getToolBar.width ? _this.getToolBar.width.toString() : null,
            minWidth: _this.getToolBar.minWidth ? _this.getToolBar.minWidth.toString() : null,
            'class-name': 'tool-bar'
          },
          scopedSlots: _this.$scopedSlots.toolbar ? {
            default: (props) => {
              return h('div', [
                _this.$scopedSlots.toolbar({
                  ...props
                })
              ])
            }
          } : null
        }) : null,
        Object.keys(_this.$slots).map(i => {
          return h('div', {
            slot: i
          }, _this.$slots[i])
        })
      ]),
      _this.showAdd ? h('div', {
        class: {
          'add-row-container': true
        },
        on: {
          click: _this.insertRow
        }
      },
      [
        h('i', {
          class: {
            'el-icon-circle-plus-outline': true
          }
        }),
        h('el-button', {
          attrs: {
            type: 'text'
          },
          domProps: {
            innerHTML: '新增行'
          }
        })
      ]) : null,
      _this.$attrs.total ? h('div', {
        ref: 'pageContainer',
        staticClass: 'table-pagination-container',
      }, [
        h('el-pagination', {
          attrs: {
            layout: 'total, sizes, prev, pager, next, jumper',
            pageSize: _this.$attrs.offset,
            total: _this.$attrs.total,
            pagerCount: _this.pagerCount
          },
          on: {
            ...this.$listeners,
            'current-change': _this._handlePageChange,
            'size-change': _this._handleSizeChange
          }
        })
      ]) : null
    ])
  },

  data() {
    return {
      selectionKey: '',
      tableHeight: 500
    }
  },
  computed: {
    getTableHeight() {
      if (this.maxHeight || this.minHeight) {
        return null
      }
      if (this.height === 'auto') {
        return this.tableHeight
      } else if (this.height) {
        return this.height
      } else {
        return null
      }
    },
    getToolBar() {
      return Object.assign({}, baseToolBar, this.toolBar)
    },
    tableConfig() {
      return Object.assign({useDefaultValidTip: true}, defaultConfig, this.$attrs.config)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this._autoHeight()
    })
  },
  updated() {
    this.$nextTick(() => {
      this.doLayout()
    })
  },
  methods: {
    _autoHeight() {
      let pageHeight = this.$refs.pageContainer ? this.$refs.pageContainer.offsetHeight : 62
      if (this.noPagination) {
        pageHeight = 0
      }
      if (this.$refs.elTable) {
        this.tableHeight = window.innerHeight - this.$refs.elTable.$el.getBoundingClientRect().top - pageHeight - Number(this.bottomSpace)
      }
    },
    _handleSelection(data) {
      if (this.selectLimit !== -1 && data.length > this.selectLimit) {
        for (let i = this.selectLimit; i < data.length; i++) {
          this.$refs.elTable.toggleRowSelection(data[i], false)
        }
        data = data.slice(0, this.selectLimit)
      }
      this.$emit('handleSelectionChange', data)
      this.$emit('selection-change', data)
      if (!data.length) {
        this.selectionKey = ''
        return
      }
      this.selectionKey = data.map(i => this._renderCellValue(i, this.rowKeyField))
    },
    _cumSelectable(row, index) {
      if (this.selectable && typeof this.selectable === 'function') {
        return this.selectable(row, index)
      }
      if (this.selectLimit === -1) {
        return true
      } else if (this.selectionKey.length >= this.selectLimit) {
        return this.selectionKey.includes(this._renderCellValue(row, this.rowKeyField))
      }
      return true
    },
    _tableRowClassName({ row, rowIndex }) {
      row.rowIndex = rowIndex
      const rowClassNameFn = this.$attrs['row-class-name'] || this.$attrs.rowClassName
      if (rowClassNameFn) {
        const className = rowClassNameFn({ row, rowIndex })
        if (this._renderCellValue(row, this.rowKeyField) && this.selectionKey.includes(this._renderCellValue(row, this.rowKeyField))) {
          return 'is-selection-row ' + className
        }
        return className
      }
      if (this._renderCellValue(row, this.rowKeyField) && this.selectionKey.includes(this._renderCellValue(row, this.rowKeyField))) {
        return 'is-selection-row'
      }
      return ''
    },
    _handleRowClick(row, column) {
      if (column && column.className && column.className.search('elx_edit') === -1) {
        if (this.showSelection && this.rowSelection) {
          if (this.selectable !== null && this.selectable !== undefined) {
            if ((typeof this.selectable === 'function' && this.selectable(row)) || (typeof this.selectable === 'boolean' && this.selectable)) {
              this.$refs.elTable.toggleRowSelection(row)
            }
          } else {
            this.$refs.elTable.toggleRowSelection(row)
          }
        }
      }
      this.$emit('row-click', row, column)
    },
    _handlePageChange(val) {
      this.$emit('current-change', val)
      this.$emit('handlePageChange', val)
    },
    _handleSizeChange(val) {
      this.$emit('size-change', val)
      this.$emit('handleSizeChange', val)
    },
    _renderCellValue(row, prop) {
      if (!prop) return ''
      if (prop.indexOf('.') !== -1) {
        const paths = prop.split('.')
        let current = row
        let result = null
        for (let i = 0, j = paths.length; i < j; i++) {
          const path = paths[i]
          if (!current) break
          if (i === j - 1) {
            result = current[path]
            break
          }
          current = current[path]
        }
        return result
      } else {
        if (row[prop] === undefined || row[prop] == null) {
          return ''
        }
        return row[prop]
      }
    },

    doLayout() {
      this.$refs.elTable.doLayout()
    },
    insertRow(index = -1, data = {}) {
      return new Promise((resolve, reject) => {
        this.$refs.elTable.insertAt(index, data).then(({ row }) => {
          this.$refs.elTable.setActiveCell(row)
          resolve({ row })
        }).catch(e => {
          reject(e)
        })
      })
    },
    deleteRows(data = {}) {
      return this.$refs.elTable.remove(data)
    },
    validate() {
      return new Promise((resolve, reject) => {
        if (!this.editable) {
          resolve()
          return
        }
        this.$refs.elTable.validate().then(() => {
          resolve(this.$attrs.data)
        }).catch(() => {
          reject('校验失败')
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "table.scss";
</style>
